export const getCompanyLink = (company) => {
    if(!company) return '';
    return company.custom_link ? company.custom_link : company.name.toLowerCase()
}